export const correctDate = (date: string | number | Date) => {
  const clientDate = new Date(date);

  clientDate.setMinutes(
    clientDate.getMinutes() - clientDate.getTimezoneOffset()
  );

  return clientDate;
};
